export default __webpack_public_path__ + "static/RecommendationEngineMobile-b6a631b60cd428c85d8d2b949879ed31.png";